import { useEffect, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import {
  Button,
  DownloadButton,
  GlobalDataTableSkeleton,
  Modal,
  MultiSelect,
  NoDataFoundTemplate,
  Select,
} from "../../../components/core";
import { useLazyQuery, useQuery } from "@apollo/client";
import { QUERY_LOCKER_TYPE } from "../../../features/locker-rental-report/locker-rental-graphql";
import { useRef } from "react";
import OverstayFeesTable from "./overstay-fees-report-table";
import {
  COUNT_OVERSTAY_DATA,
  GET_AGGREGATE_OVERSTAY_FEES_REPORT,
  GET_OVERSTAY_FEES_REPORT,
  MONTHLY_OVERSTAY_FEES_REPORT,
} from "../../../constants/graphql/overstay-fees-report";
import PrimereactDateRange from "../../../components/core/date-range-primereact";
import { InputText } from "primereact/inputtext";
import { LOCKER_INFO } from "../../../constants/graphql/locker-queries";
import {
  formatDate as globalFormatDate,
  toUTCDateTimeString,
} from "../../../algorithms/date";
import { NEWEST_LOCKER_NAME_QUERY } from "../../../features/stay-time-in-locker/stay-time-query/stay-time-graphql";
import AggregateOverstayFeesTable from "./aggregate-overstay-table";
import TransactionCard from "./transaction-card";
import { Card } from "primereact/card";
import { computeAggregateFromBackend } from "../../../utils/compute-aggregate";

export const paymentCurrency = [
  { value: "1", name: "PHP" },
  { value: "2", name: "MBOX COINS" },
];

export const computeTotalPackages = (data) => {
  return data.reduce((total, row) => total + row.totalTransactions, 0);
};

const OverstayFeesReport = () => {
  const dt = useRef(null);

  const operatorId = JSON.parse(localStorage.getItem("user")).operator_id;

  const [filterVariables, setFilterVariables] = useState({
    transactionStatus: "-1",
    mobileNumFilter: "",
    waybillNumFilter: "",
    lockerType: "-1",
    selectedLockerName: [],
    paymentIdFilter: "",
    paymentCurrencyFilter: "-1",
    doorSizeFilter: "-1",
    startDate: (() => {
      const d = new Date();
      d.setMonth(d.getMonth() - 6);
      return d;
    })(),
    endDate: new Date(),
    endTime: "23:59",
    startTime: "00:00",
  });
  const [lockerType, setLockerType] = useState([]);
  const [lockerName, setLockerName] = useState([]);
  const [selectedLockerName, setSelectedLockerName] = useState([]);

  // table visibility
  const [isClicked, setIsClicked] = useState(false);
  // const [isLoading, setIsLoading] = useState(false);
  const [showMorePaymentDetails, setShowMorePyamentDetails] = useState(false);

  const [searchResultHeader, setSearchResultHeader] = useState("");

  // const [startDate, setStartDate] =
  // 	useState();
  // new Date().toISOString().split("T")[0]
  const [allPaymentDate, setAllPaymentDate] = useState(true);
  const [allLockersSelected, setAllLockersSelected] = useState(false);
  const [nameData, setNameData] = useState([]);
  // const [isLoading, setIsLoading] = useState(false);
  const [totalAmt, setTotalAmt] = useState({
    php: 0,
    coins: 0,
  });
  const [totalSuccessTrans, setTotalSuccessTrans] = useState({
    storage: {
      php: 0,
      coins: 0,
    },
    dropOff: {
      php: 0,
      coins: 0,
    },
    subtotal: 0,
  });

  const [totalTransactions, setTotalTransactions] = useState({
    success: { php: 0, coins: 0 },
    duplicates: { php: 0, coins: 0 },
    failed: { php: 0, coins: 0 },
    total: { php: 0, coins: 0 },
  });
  const [totalDuplicates, setTotalDuplicates] = useState({
    storage: { php: "0.00", coins: "0.00" },
    dropOff: { php: "0.00", coins: "0.00" },
    subtotal: { php: "0.00", coins: "0.00" },
  });
  const [totalRefunded, setTotalRefunded] = useState({
    storage: { php: "0.00", coins: "0.00" },
    dropOff: { php: "0.00", coins: "0.00" },
    subtotal: { php: "0.00", coins: "0.00" },
  });
  const [totalFailedTrans, setTotalFailed] = useState({
    storage: {
      php: 0,
      coins: 0,
    },
    dropOff: {
      php: 0,
      coins: 0,
    },
    subtotal: 0,
  });
  const [totalGrossSales, setTotalGrossSales] = useState({
    storage: { php: "0.00", coins: "0.00" },
    dropOff: { php: "0.00", coins: "0.00" },
    subtotal: { php: "0.00", coins: "0.00" },
  });

  // validation
  const [validation, setValidation] = useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });

  // default options
  const transActStatus = [
    { value: "1", name: "Successful" },
    { value: "2", name: "Failed" },
  ];

  // gql queries
  const [
    fetchOverstayFees,
    { data: overstayFeesLazyData, loading: loadingOverstayData },
  ] = useLazyQuery(GET_OVERSTAY_FEES_REPORT);
  const [
    fetchAggregateOverstayFees,
    { data: aggregateOverstayFees, loading: loadingAggregateData },
  ] = useLazyQuery(GET_AGGREGATE_OVERSTAY_FEES_REPORT);

  const fetchLockerType = useQuery(QUERY_LOCKER_TYPE);
  const [fetchLockerName, { data: lockerNameData }] = useLazyQuery(
    NEWEST_LOCKER_NAME_QUERY,
    {
      variables: {
        operatorId: operatorId,
      },
    },
  );
  const { data: allLockerNames } = useQuery(LOCKER_INFO, {
    variables: {
      operatorId: operatorId,
    },
  });

  // table datatable
  const [batchResults, setBatchResults] = useState([]);
  const [pendingBatches, setPendingBatches] = useState(0);
  const [isLoadingBatches, setIsLoadingBatches] = useState(false);
  const isLoading =
    isLoadingBatches || loadingOverstayData || loadingAggregateData;

  // handle change filter variables
  const handleFilterChange = (e, field) => {
    setIsClicked(false);
    let value = e.target.value;

    if (field === "startDate" || field === "endDate") {
      value = value ? new Date(value) : null;
    }
    if (field === "lockerType") {
      setFilterVariables({
        ...filterVariables,
        [field]: value,
        selectedLockerName: [],
      });
    } else {
      setFilterVariables({
        ...filterVariables,
        [field]: value,
      });
    }
  };

  const buildVariables = () => {
    const updatedVariables = {};
    const operatorId = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user")).operator_id
      : "";

    // always assign operatorid
    updatedVariables.operatorId = operatorId;

    if (filterVariables.transactionStatus !== "-1") {
      updatedVariables.transactionStatus = filterVariables.transactionStatus;
    }

    if (filterVariables.mobileNumFilter !== "") {
      updatedVariables.mobileNumber = filterVariables.mobileNumFilter;
    }

    if (filterVariables.waybillNumFilter !== "") {
      updatedVariables.waybillNumber = filterVariables.waybillNumFilter;
    }

    if (filterVariables.lockerType !== "-1") {
      updatedVariables.lockerType = filterVariables.lockerType;
    }

    if (filterVariables.selectedLockerName.length !== 0) {
      const lockerIdValues = filterVariables.selectedLockerName.map(
        (locker) => locker.value,
      );

      updatedVariables.lockerIds = lockerIdValues;
    }

    if (filterVariables.paymentIdFilter !== "") {
      updatedVariables.paymentId = filterVariables.paymentIdFilter;
    }

    if (filterVariables.paymentCurrencyFilter !== "-1") {
      updatedVariables.paymentCurrency =
        filterVariables.paymentCurrencyFilter === "1" ? "PHP" : "PHMC";
    }

    if (filterVariables.doorSizeFilter !== "-1") {
      updatedVariables.doorSizeId = parseInt(filterVariables.doorSizeFilter);
    }

    if (filterVariables.startDate) {
      updatedVariables.transactionDateStart = toUTCDateTimeString(
        new Date(filterVariables.startDate),
        filterVariables.startTime || "00:00",
      );
    }

    if (filterVariables.endDate) {
      updatedVariables.transactionDateEnd = toUTCDateTimeString(
        new Date(filterVariables.endDate),
        filterVariables.endTime || "23:59",
      );
    }

    return updatedVariables;
  };

  // for table header
  function handleSearchResultHeader() {
    let startDate, endDate;
    let formattedStart, formattedEnd;
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };

    if (filterVariables.startDate && filterVariables.endDate) {
      startDate = new Date(filterVariables.startDate);
      endDate = new Date(filterVariables.endDate);

      formattedStart = startDate.toLocaleDateString(undefined, options);
      formattedEnd = endDate.toLocaleDateString(undefined, options);
    }

    const lockerTypeName =
      filterVariables.lockerType === "-1"
        ? "ALL Locker types"
        : filterVariables.lockerType === "1"
          ? "Parcel Locker"
          : "Fridge Locker";

    let lockerNameText;
    if (allLockersSelected) {
      lockerNameText = "ALL Lockers";
    } else {
      const lockerLabels = filterVariables.selectedLockerName
        .map((selectedLocker) => {
          const matchedLocker = lockerName.find(
            (item) => parseInt(item.value) === parseInt(selectedLocker.value),
          );
          return matchedLocker ? matchedLocker.label : null;
        })
        .filter((label) => label !== null);

      lockerNameText =
        lockerLabels.length > 0 ? lockerLabels.join(", ") : "ALL Lockers";
    }

    const transActNameValue =
      filterVariables.transactionStatus === -1 ||
      filterVariables.transactionStatus === "-1"
        ? ""
        : transActStatus.find(
            (item) => item.value === filterVariables.transactionStatus,
          );
    const transActNameText =
      transActNameValue !== ""
        ? `${transActNameValue.name} Transactions`
        : "ALL Transaction Status";

    const mobileHeader =
      filterVariables.mobileNumFilter !== ""
        ? filterVariables.mobileNumFilter
        : "ALL Mobile Numbers";

    const waybillHeader =
      filterVariables.waybillNumFilter !== ""
        ? filterVariables.waybillNumFilter
        : "ALL Packages";

    const paymentIDHeader =
      filterVariables.paymentIdFilter !== ""
        ? `Payment ID: ${filterVariables.paymentIdFilter}`
        : "";

    setSearchResultHeader(`for
			${transActNameText},
			${lockerTypeName},
			${lockerNameText},
			${mobileHeader},
			${waybillHeader},
			${paymentIDHeader},
			from ${globalFormatDate(filterVariables.startDate)} to ${globalFormatDate(
        filterVariables.endDate,
      )}
		`);
  }

  useEffect(() => {
    if (fetchLockerType.data) {
      let tempData = [];
      fetchLockerType.data.lockerTypes.forEach((element) => {
        tempData.push({
          value: element.lockerTypeId,
          name: element.lockerType,
        });
      });
      setLockerType(tempData);
    }
  }, [fetchLockerType.data]);

  useEffect(() => {
    if (filterVariables.lockerType !== "-1") {
      // fetchLockerName({
      // 	operatorId: operatorId,
      // 	selectedLockerType: selectedLockerType,
      // });
      fetchLockerName({
        variables: {
          operatorId: operatorId,
          lockerTypeId: filterVariables.lockerType,
        },
      });
    }
  }, [filterVariables.lockerType, operatorId]);

  useEffect(() => {
    if (lockerNameData) {
      const tempData = lockerNameData.lockerInfo.map((element) => ({
        label: element.lockerName,
        value: element.lockerId,
      }));

      if (!allLockersSelected) {
        tempData.unshift({
          value: 0,
          label: "All Lockers",
        });
      }

      setLockerName(tempData);
    }
  }, [lockerNameData, allLockersSelected]);

  useEffect(() => {
    const selected = filterVariables.selectedLockerName;
    const allLockers = lockerName;

    const hasZeroValue = selected.some((item) => item.value === 0);

    if (hasZeroValue) {
      setAllLockersSelected(true);
    } else if (selected.length === 0) {
      setAllLockersSelected(false);
    } else if (selected.length !== allLockers.length) {
      setAllLockersSelected(false);
    } else {
      setAllLockersSelected(true);
    }
  }, [filterVariables.selectedLockerName, lockerName]);

  useEffect(() => {
    if (allLockersSelected) {
      const selectedLockers = lockerName.filter((locker) => locker.value !== 0);

      setFilterVariables({
        ...filterVariables,
        selectedLockerName: selectedLockers,
      });
    }
  }, [allLockersSelected, lockerName]);
  useEffect(() => {
    if (allLockerNames && allLockerNames.lockerInfo) {
      const lockerDetails = allLockerNames.lockerInfo.map((locker) => ({
        lockerId: locker.lockerId,
        lockerName: locker.lockerName,
      }));
      setNameData(lockerDetails);
    }
  }, [allLockerNames]);

  const [overstayTableData, setOverstayTableData] = useState([]);

  useEffect(() => {
    if (!isClicked) return;
    if (filterVariables.selectedLockerName.length !== 0) return;

    if (aggregateOverstayFees && aggregateOverstayFees.aggregateOverstayFees) {
      if (aggregateOverstayFees.aggregateOverstayFees.length > 0) {
        const {
          tableData,
          totalAmt: amt,
          statusBySvc,
          totalTxns,
          grossSales,
        } = computeAggregateFromBackend(
          [],
          aggregateOverstayFees.aggregateOverstayFees,
          nameData,
          // findLockerName,
          {
            includeRefunds: true,
            forAggregate: true,
          },
        );
        setOverstayTableData(tableData);
        setTotalAmt(amt);
        setTotalRefunded(statusBySvc.refunded);
        setTotalDuplicates(statusBySvc.duplicates);
        setTotalGrossSales(grossSales.subtotal);
        setTotalSuccessTrans(statusBySvc.success);
        setTotalFailed(statusBySvc.failed);
        setTotalTransactions(totalTxns);
      } else {
        setOverstayTableData([]);
      }
    }
  }, [
    aggregateOverstayFees,
    nameData,
    isClicked,
    filterVariables.selectedLockerName.length,
  ]);

  const handleSearch = () => {
    setIsClicked(true);
    // clearTableState();
    setShowMorePyamentDetails(false);
    handleSearchResultHeader();

    const variable = buildVariables();

    // Case 1: No locker selected
    if (filterVariables.selectedLockerName.length === 0) {
      if (filterVariables.lockerType !== "-1") {
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
          title: "Invalid Locker",
          message: `Please select a locker name.`,
          open: true,
          actions: (
            <div className="w-full">
              <Button
                onClick={() => setValidation({ open: false })}
                value={"OK"}
                className={"p-2 w-full"}
              />
            </div>
          ),
        });
        setIsClicked(false);
        return;
      }

      fetchAggregateOverstayFees({
        variables: variable,
      });
      return;
    }

    // Case 2: Locker name selected → fetch detailed data
    const BATCH_SIZE = 4;
    const selectedLockers = filterVariables.selectedLockerName;

    // If 4 or fewer lockers, call once and let useEffect handle it
    if (selectedLockers.length <= BATCH_SIZE) {
      fetchOverstayFees({
        variables: variable,
      });
      return;
    }

    // For more than 4 lockers, process in batches
    const batches = [];
    for (let i = 0; i < selectedLockers.length; i += BATCH_SIZE) {
      batches.push(selectedLockers.slice(i, i + BATCH_SIZE));
    }

    console.log(`Will process ${batches.length} batches`);

    // Reset batch tracking
    setBatchResults([]);
    setPendingBatches(batches.length);
    setIsLoadingBatches(true);

    // Call fetchOverstayFees for each batch
    batches.forEach((batch, index) => {
      console.log(
        `Calling batch ${index + 1}/${batches.length} with lockers:`,
        batch,
      );

      fetchOverstayFees({
        variables: {
          ...variable,
          lockerIds: batch.map((locker) => locker.value),
        },
      })
        .then((response) => {
          console.log(`Batch ${index + 1} response:`, response);

          if (response?.data?.overstayFees) {
            const batchData = response.data.overstayFees;
            console.log(`Batch ${index + 1} got ${batchData.length} results`);

            setBatchResults((prev) => [...prev, ...batchData]);
          }

          setPendingBatches((prev) => prev - 1);
        })
        .catch((error) => {
          console.error(`Batch ${index + 1} error:`, error);
          setPendingBatches((prev) => prev - 1);
        });
    });
  };

  // ONLY handle single queries (≤ 4 lockers) - NOT batch results
  useEffect(() => {
    if (!isClicked) return;
    if (isLoadingBatches) return; // Skip if in batch mode

    if (overstayFeesLazyData && overstayFeesLazyData.overstayFees) {
      const currentResults = overstayFeesLazyData.overstayFees;
      console.log(`Single query result:`, currentResults);

      if (currentResults.length > 0) {
        const {
          tableData,
          totalAmt: amt,
          statusBySvc,
          totalTxns,
          grossSales,
        } = computeAggregateFromBackend(currentResults, [], nameData, {
          includeRefunds: true,
          forAggregate: false,
        });

        updateTableState(tableData, amt, statusBySvc, totalTxns, grossSales);
      } else {
        // clearTableState();
      }
    }
  }, [overstayFeesLazyData, nameData, isClicked, isLoadingBatches]);

  // Handle combined batch results when all batches complete
  useEffect(() => {
    if (!isLoadingBatches || pendingBatches > 0) return;

    console.log(
      `All batches complete! Processing ${batchResults.length} total results`,
    );

    if (batchResults.length > 0) {
      const {
        tableData,
        totalAmt: amt,
        statusBySvc,
        totalTxns,
        grossSales,
      } = computeAggregateFromBackend(batchResults, [], nameData, {
        includeRefunds: true,
        forAggregate: false,
      });

      updateTableState(tableData, amt, statusBySvc, totalTxns, grossSales);
    } else {
      // clearTableState();
    }

    // Reset batch state
    setIsLoadingBatches(false);
    setBatchResults([]);
  }, [pendingBatches, isLoadingBatches, batchResults, nameData]);

  // Helper functions
  const updateTableState = (
    tableData,
    amt,
    statusBySvc,
    totalTxns,
    grossSales,
  ) => {
    setOverstayTableData(tableData);
    setTotalAmt(amt);
    setTotalSuccessTrans(statusBySvc.success);
    setTotalGrossSales(grossSales.subtotal);
    setTotalRefunded(statusBySvc.refunded);
    setTotalDuplicates(statusBySvc.duplicates);
    setTotalFailed(statusBySvc.failed);
    setTotalTransactions(totalTxns);
  };

  const clearTableState = () => {
    setOverstayTableData([]);
    setTotalAmt(0);
    setTotalSuccessTrans(0);
    setTotalGrossSales(0);
    setTotalRefunded(0);
    setTotalDuplicates(0);
    setTotalFailed(0);
    setTotalTransactions(0);
  };

  const togglePaymentIDVisiblity = () => {
    setShowMorePyamentDetails(!showMorePaymentDetails);
  };

  console.log({ overstayTableData });
  return (
    <ContentContainer containerTitle={"Overstay Fees Report"}>
      <div>
        <h2 className={"font-bold"}>Transaction Details:</h2>
        <div className={"grid grid-cols-8 items-center w-full gap-y-2"}>
          <div className="col-span-6 grid">
            <div className="grid grid-cols-3 w-full items-center">
              <div className="col-span-1">Transaction Status:</div>
              <Select
                items={transActStatus}
                className={"col-span-2"}
                value={filterVariables.transactionStatus}
                defaultOption={{ value: "-1", name: "--- ALL ---" }}
                onChange={(event) => {
                  handleFilterChange(event, "transactionStatus");
                }}
              />
            </div>
          </div>

          <div className="col-span-2"></div>
          <div className="col-span-6 grid">
            <div className="grid grid-cols-12 w-full items-center">
              <div className={"col-span-4"}>
                Sender / Recipient Mobile Number:
              </div>
              <div className={"col-span-1"}>+63</div>
              <InputText
                keyfilter={"int"}
                placeholder={"XXXXXXXXX"}
                useGrouping={false}
                maxLength={10}
                value={filterVariables.mobileNumFilter}
                onChange={(event) => {
                  handleFilterChange(event, "mobileNumFilter");
                }}
                className="col-span-7 px-4 "
                pt={{
                  root: {
                    className: "border border-gray-200 rounded-lg w-full h-10",
                  },
                }}
              />
            </div>
          </div>

          <div className="col-span-2"></div>
          <div className="col-span-6 grid">
            <div className="grid grid-cols-12 w-full items-center">
              <div className={"col-span-4"}>Waybill Number:</div>
              <InputText
                // keyfilter={"int"}
                placeholder={"XXXXXXXXXXXXXXXXX"}
                useGrouping={false}
                maxLength={32}
                value={filterVariables.waybillNumFilter}
                onChange={(event) => {
                  handleFilterChange(event, "waybillNumFilter");
                }}
                className="col-span-8 px-4 "
                pt={{
                  root: {
                    className: "border border-gray-200 rounded-lg w-full h-10",
                  },
                }}
              />
            </div>
          </div>
        </div>

        <h2 className={"font-bold pt-4"}>
          Locker:
          <span className="font-normal text-xs italic ml-2 text-blue-700">
            (to view each transaction, please select locker type and locker name
            from the list)
          </span>
        </h2>
        <div className={"grid grid-cols-8 items-center w-full gap-y-2"}>
          <div className="col-span-6 grid">
            <div className="grid grid-cols-3 w-full items-center">
              <div className={"col-span-1"}>Locker Type:</div>
              <Select
                items={lockerType}
                value={filterVariables.lockerType}
                defaultOption={{ value: "-1", name: "-- ALL--" }}
                onChange={(event) => {
                  handleFilterChange(event, "lockerType");
                }}
                className={"col-span-2"}
              />
            </div>
          </div>
          <div className="col-span-2"></div>

          <div className="col-span-6 grid">
            <div className="grid grid-cols-3 w-full items-center">
              <div className={"col-span-1"}>Locker Name:</div>
              <MultiSelect
                className={"col-span-2"}
                items={lockerName}
                placeholder={`${
                  filterVariables.lockerType === "-1"
                    ? "ALL Lockers"
                    : "Select..."
                }`}
                value={filterVariables.selectedLockerName}
                disabled={filterVariables.lockerType === "-1"}
                onChange={(event) => {
                  // setSelectedLockerName(event.target.value);
                  handleFilterChange(event, "selectedLockerName");
                }}
              />
            </div>
          </div>
        </div>

        <h2 className={"font-bold pt-4"}>
          Payment Details:{" "}
          {/* <span className="font-normal text-xs italic ml-2 text-blue-700">
						(to filter by payment date, please select a locker name)
					</span> */}
        </h2>
        <div className={"grid grid-cols-8 items-center w-full gap-y-2"}>
          <div className="col-span-6 grid">
            <div className="grid grid-cols-3 w-full items-center">
              <div className={"col-span-1"}>Payment ID:</div>
              <InputText
                keyfilter={"int"}
                placeholder={"XXXX"}
                className={"col-span-2 px-4"}
                value={filterVariables.paymentIdFilter}
                maxLength={32}
                onChange={(event) => {
                  handleFilterChange(event, "paymentIdFilter");
                }}
                pt={{
                  root: {
                    className: "border border-gray-200 rounded-lg w-full h-10",
                  },
                }}
              />
            </div>
          </div>
          <div className="col-span-2"></div>

          <div className="col-span-6 grid">
            <div className="grid grid-cols-3 w-full items-center">
              <div className={"col-span-1"}>Payment Currency:</div>
              <Select
                items={paymentCurrency}
                className={"col-span-2"}
                value={filterVariables.paymentCurrencyFilter}
                onChange={(event) => {
                  // setPaymentCurrencyFilter(event.target.value);
                  handleFilterChange(event, "paymentCurrencyFilter");
                }}
                defaultOption={{ value: "-1", name: "-- ALL--" }}
              />
            </div>
          </div>
          <div className="col-span-2"></div>

          <div className="col-span-6 grid">
            <div className="grid grid-cols-3 w-full items-center">
              <div className={"col-span-1"}>Door Size:</div>
              <Select
                items={[
                  { value: "1", name: "Small" },
                  { value: "2", name: "Medium" },
                  { value: "3", name: "Large" },
                ]}
                className={"col-span-2"}
                value={filterVariables.doorSizeFilter}
                onChange={(event) => {
                  handleFilterChange(event, "doorSizeFilter");
                }}
                defaultOption={{ value: "-1", name: "-- ALL --" }}
              />
            </div>
          </div>
          <div className="col-span-2"></div>

          <div className="col-span-6 grid">
            <div className="grid grid-cols-3 w-full items-center">
              <div className={"col-span-1"}>Payment Date filter:</div>
              <PrimereactDateRange
                className={`col-span-2`}
                startDate={filterVariables.startDate}
                endDate={filterVariables.endDate}
                startTime={filterVariables.startTime}
                endTime={filterVariables.endTime}
                startDateName="startDate"
                endDateName="endDate"
                startTimeName="startTime"
                endTimeName="endTime"
                onChange={(event, fieldName) => {
                  handleFilterChange(event, fieldName);
                }}
                readOnlyInput={true}
                max={new Date()}
                timeOnly={true}
                // commented out to be able to filter 2024 data
                // min={maxDate}
              />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-12 w-full gap-y-2">
          <div className="col-span-8"></div>
          <u
            className="flex hover:text-blue-500 cursor-pointer mt-4 ml-auto w-min"
            onClick={() => {
              const threeMonthsAgo = new Date();
              threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 6);

              setFilterVariables({
                ...filterVariables,
                startDate: threeMonthsAgo,
                endDate: new Date(),
                selectedLockerName: [],
                transactionStatus: "-1",
                mobileNumFilter: "",
                waybillNumFilter: "",
                lockerType: "-1",
                paymentIdFilter: "",
                paymentCurrencyFilter: "-1",
                doorSizeFilter: "-1",
                endTime: "23:59",
                startTime: "00:00",
              });

              setAllPaymentDate(true);
              setIsClicked(false);
              // setUserNumber("");
            }}
          >
            <i className="fas fa-undo my-auto"></i>
            <p className="ml-1">Reset</p>
          </u>
        </div>

        <Button
          value={"Search"}
          disabled={isLoading}
          // disabled={loadingAggregateData || loadingOverstayData}
          onClick={handleSearch}
          className={"w-40 h-8 m-5"}
        />

        {isClicked &&
          (isLoading ? (
            <GlobalDataTableSkeleton totalColumns={8} parentClassName="mx-4" />
          ) : overstayTableData.length === 0 ? (
            <NoDataFoundTemplate />
          ) : (
            <Card className="mx-4">
              <div
                className={`${overstayTableData.length === 0 ? "hidden" : ""}`}
              >
                {/* {tableData.map((item, index) => ( */}
                <div className="mt-5">
                  {/* <div>
                    <Checkbox
                      disabled={filterVariables.selectedLockerName.length === 0}
                      checked={showMorePaymentDetails}
                      onChange={togglePaymentIDVisiblity}
                      label="Show More Payment Details"
                    />
                  </div> */}
                  <DownloadButton dt={dt} csvOnly={true} />

                  <div className={" bg-yellow-400 p-2 "}>
                    <div className={"text-center"}>
                      <span>
                        <h1 className={"font-bold"}>OVERSTAY FEES REPORTS</h1>
                      </span>
                      <span>
                        <h1 className={"font-bold"}>{searchResultHeader} </h1>
                      </span>
                    </div>
                  </div>

                  <>
                    <div className="p-2 grid grid-cols-8">
                      <div className={`col-span-1`}></div>

                      {(filterVariables.paymentCurrencyFilter === "-1" ||
                        filterVariables.paymentCurrencyFilter === "1") && (
                        <div
                          className={`px-2 ${
                            filterVariables.paymentCurrencyFilter === "-1"
                              ? "col-span-3"
                              : "col-span-6"
                          }`}
                          style={{ display: "grid" }}
                        >
                          <TransactionCard
                            currencyType="PHP"
                            forOverstay={true}
                            data={overstayTableData}
                            totalAmt={totalAmt}
                            totalGrossSales={totalGrossSales}
                            totalTransactions={totalTransactions.total}
                            totalSuccessTrans={totalSuccessTrans}
                            totalRefund={totalRefunded}
                            totalFailedTrans={totalFailedTrans}
                            totalDuplicates={totalDuplicates}
                          />
                        </div>
                      )}

                      {(filterVariables.paymentCurrencyFilter === "-1" ||
                        filterVariables.paymentCurrencyFilter === "2") && (
                        <div
                          className={`px-2 ${
                            filterVariables.paymentCurrencyFilter === "-1"
                              ? "col-span-3"
                              : "col-span-6"
                          }`}
                          style={{ display: "grid" }}
                        >
                          <TransactionCard
                            currencyType="MBOX COINS"
                            data={overstayTableData}
                            forOverstay={true}
                            totalAmt={totalAmt}
                            totalGrossSales={totalGrossSales}
                            totalRefund={totalRefunded}
                            totalTransactions={totalTransactions.total}
                            totalSuccessTrans={totalSuccessTrans}
                            totalFailedTrans={totalFailedTrans}
                            totalDuplicates={totalDuplicates}
                          />
                        </div>
                      )}
                      <div className={`col-span-1`}></div>
                    </div>
                  </>

                  {filterVariables.selectedLockerName.length === 0 ? (
                    <AggregateOverstayFeesTable
                      dt={dt}
                      multiItemField={false}
                      items={overstayTableData}
                      showMorePaymentDetails={showMorePaymentDetails}
                    />
                  ) : (
                    <OverstayFeesTable
                      dt={dt}
                      multiItemField={false}
                      items={overstayTableData}
                      showMorePaymentDetails={showMorePaymentDetails}
                      dateRange={`${globalFormatDate(
                        new Date(filterVariables.startDate),
                      )} - ${globalFormatDate(
                        new Date(filterVariables.endDate),
                      )}`}
                    />
                  )}
                </div>
                {/* ))} */}
              </div>
            </Card>
          ))}

        <Modal
          icon={validation.icon}
          title={validation.title}
          message={validation.message}
          open={validation.open}
          actions={validation.actions}
        />
      </div>
    </ContentContainer>
  );
};

export default OverstayFeesReport;
